export default __webpack_public_path__ + "static/media/tea.e1a326fa.png";